<template>
  <div
    @click="bookmark"
    :class="[
      'bookmark-button v-toolbar__button',
      { '--bookmarked': isBookmarked || isBookmarking }
    ]"
    data-cy="bookmark-button"
  >
    <template v-if="isBookmarking">
      <v-loader />
    </template>
    <template v-else-if="isBookmarked">
      <v-icon icon="beenhere" />
    </template>
    <template v-else>
      <v-icon icon="bookmark" />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  props: {
    pageId: { type: Number, required: true }
  },

  data() {
    return {
      isBookmarking: false
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("pages", ["isPageBookmarked"]),

    isBookmarked() {
      return this.isPageBookmarked(this.pageId)
    }
  },

  methods: {
    ...mapActions("pages", ["togglePageBookmark"]),

    bookmark() {
      if (!this.isAuthenticated) {
        this.$router.push("#auth")

        return false
      }

      this.isBookmarking = true

      this.togglePageBookmark(this.pageId)
        .then(isBookmarked =>
          this.$notify(
            isBookmarked ? "Added to your content" : "Removed from your content"
          )
        )
        .finally(() => {
          this.isBookmarking = false
        })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

.bookmark-button {
  &.--bookmarked {
    background: $color-ui--white !important;
    box-shadow: $box-shadow--medium !important;
    color: $color-ui--grey-70 !important;
  }
}
</style>
